import { render } from "./ProjectSolarWinds.vue?vue&type=template&id=f20fddb8"
import script from "./ProjectSolarWinds.vue?vue&type=script&lang=js"
export * from "./ProjectSolarWinds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__